import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PendingChangesGuard, SiteRootState } from '@next/core-lib/site';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { BalanceComponent } from '../components/balance/balance.component';
import * as cycleActions from '../store/actions/cycle.actions';

@Injectable({
  providedIn: 'root',
})
export class PendingBalanceGuard {
  private store = inject<Store<SiteRootState>>(Store);
  private pendingChangesGuard = inject(PendingChangesGuard);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}
  canDeactivate(
    _component: BalanceComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (
      (nextState && nextState.url.indexOf('/delivery/add') !== -1) ||
      nextState.url.indexOf('/balance') !== -1
    ) {
      return true;
    }
    this.store.dispatch(
      cycleActions.setRouteTransitionBalance({
        routeTransitionBalance: null,
      }),
    );
    return this.pendingChangesGuard.canDeactivate();
  }
}
